import cookie from 'js-cookie'
import request from 'local_modules/request'
import actions from 'redux/actions'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


// const setActive = (isActive) => {
//   Cookie.set('marketplaceLayerNavigation', `${isActive}`)
//   reducers.marketplace.layersNavigation.setActive(isActive)
// }

const setCategory = (categoryId) => {
  const { marketplace: { layersNavigation: { category } } } = getState()

  if (categoryId === category) {
    return
  }

  actions.cookies.setItem('category', categoryId)
  reducers.marketplace.layersNavigation.setCategory(categoryId)

  if (cookie.get('area') || cookie.get('tool') || cookie.get('toolType')) {
    reducers.marketplace.layersNavigation.setWelcomeHidden(true)
  }

  actions.cookies.removeItem('area')
  actions.cookies.removeItem('tool')
  actions.cookies.removeItem('toolType')
  reducers.marketplace.layersNavigation.setArea(null)
  reducers.marketplace.layersNavigation.setTool(null)
  reducers.marketplace.layersNavigation.setToolType(null)
}

const setCategories = (categories) => {
  reducers.marketplace.layersNavigation.setCategories(categories)
}

const setArea = (areaId) => {
  actions.cookies.setItem('area', areaId)
  reducers.marketplace.layersNavigation.setArea(areaId)
}

const setTool = (toolId) => {
  actions.cookies.setItem('tool', toolId)
  reducers.marketplace.layersNavigation.setTool(toolId)
}

const setToolType = (toolTypeId) => {
  const { marketplace: { layersNavigation: { toolType } } } = getState()

  if (toolTypeId === toolType) {
    return
  }

  actions.cookies.setItem('toolType', toolTypeId)
  reducers.marketplace.layersNavigation.setToolType(toolTypeId)

  if (cookie.get('area') || cookie.get('tool')) {
    reducers.marketplace.layersNavigation.setWelcomeHidden(true)
  }

  actions.cookies.removeItem('area')
  actions.cookies.removeItem('tool')
  actions.marketplace.layersNavigation.setTool(null)
  actions.marketplace.layersNavigation.setArea(null)
}

const fetchTools = (areaId) => (
  request.get(constants.marketplace.environmentTool + `/${areaId}`)
    .then(({ data }) => data)
    .then((tools) => {
      reducers.marketplace.layersNavigation.setTools(tools)
    })
    .catch((error) => {
      console.log(error)
    })
)

// Fetch actions from initialState

// Tools
const getToolsByType = ({ id, name, active }) => {
  return request.get(constants.marketplace.environmentToolType + `/${id}`)
    .then(({ data }) => ({ id, name, active, areas: data }))
}

const fetchSportTools = () => (
  request.get(constants.marketplace.environmentToolType)
    .then(({ data }) => data)
    .then((data) => (
      Promise.all(
        data.map(({ id, name, active }) => getToolsByType({ id, name, active }))
      )
    ))
)

const fetchEduTools = () => {
  return (
    request.get(constants.edu.categories)
      .then(({ data }) => data)
  )
}

const fetchRpcTools = () => (
  request.get(constants.rpc.categories)
    .then(({ data }) => data)
  // [{
  //   "id": 2,
  //   "title": "Православная гимназия",
  //   "description": "Услуги питания в православной гимназии",
  //   "active": true,
  //   "created": "2019-08-21T11:11:12"
  // }]
)

const fetchAllTools = () => (
  Promise.all([
    fetchSportTools(),
    fetchEduTools(),
    fetchRpcTools().catch((error) => console.error('fetchRpcTools error', error)),
  ])
    .then(([ sport, edu, rpc ]) => {
      reducers.marketplace.layersNavigation.setTools(sport)
      reducers.marketplace.layersNavigation.setNomenclature(edu)
      reducers.marketplace.layersNavigation.setRpcNomenclature(rpc)
    })
)

// Areas
const fetchAreas = () => {
  return request.get(constants.marketplace.environmentArea)
    .then(({ data }) => data)
    .then((areas) => {
      reducers.marketplace.layersNavigation.setAreas(areas)
    })
}

// Cookies
const setActiveToolsFromCookie = () => {
  const { routing: { locationBeforeTransitions: { pathname } } } = getState()

  const isRedirected = cookie.get('isRedirected')

  if (!/\/marketplace\/?/.test(pathname) || isRedirected) {
    const toolCookieValue     = Number(cookie.get('tool')) || null
    const toolTypeCookieValue = Number(cookie.get('toolType')) || null
    const areaCookieValue     = Number(cookie.get('area')) || null
    const categoryCookieValue = cookie.get('category')

    console.log(cookie.getJSON())

    if (isRedirected) {
      cookie.remove('isRedirected')
    }

    reducers.marketplace.layersNavigation.setTool(toolCookieValue)
    reducers.marketplace.layersNavigation.setToolType(toolTypeCookieValue)
    reducers.marketplace.layersNavigation.setArea(areaCookieValue)
    reducers.marketplace.layersNavigation.setCategory(categoryCookieValue)
  }

  return Promise.resolve()
}

const fetch = () => {
  return Promise.all([
    fetchAllTools(),
    fetchAreas(),
    setActiveToolsFromCookie(),
  ])
    .then(() => reducers.marketplace.layersNavigation.setFetched(true))
}


export default {
  // setActive,
  setCategory,
  setCategories,
  setArea,
  setTool,
  setToolType,
  fetchTools,
  fetch,
}
